import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
export function StickyMobileCTA() {
  const [isVisible, setIsVisible] = useState(false);
  useEffect(() => {
    const handleScroll = () => {
      // Show after scrolling down 500px
      if (window.scrollY > 500) {
        setIsVisible(true);
      } else {
        setIsVisible(false);
      }
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  const handleBuy = () => {
    console.log('Buy clicked');
    // In a real app, this would scroll to pricing or open checkout
    document.getElementById('oferta')?.scrollIntoView({
      behavior: 'smooth'
    });
  };
  return <AnimatePresence data-id="element-248">
      {isVisible && <motion.div initial={{
      y: 100,
      opacity: 0
    }} animate={{
      y: 0,
      opacity: 1
    }} exit={{
      y: 100,
      opacity: 0
    }} className="fixed bottom-0 left-0 right-0 z-40 bg-navy-800/95 backdrop-blur-md border-t border-navy-700 p-4 md:hidden shadow-[0_-10px_30px_rgba(0,0,0,0.5)]" data-id="element-249">
          <div className="flex items-center justify-between gap-4" data-id="element-250">
            <div className="flex flex-col" data-id="element-251">
              <span className="text-xs text-text-secondary line-through" data-id="element-252">
                $49.990
              </span>
              <span className="text-xl font-display text-gold-400" data-id="element-253">
                $19.990 ARS
              </span>
            </div>
            <button onClick={handleBuy} className="flex-1 bg-gold-500 hover:bg-gold-400 text-navy-900 font-display text-xl py-3 px-4 rounded shadow-[0_0_15px_rgba(212,168,87,0.4)] transition-all active:scale-95 uppercase tracking-wide" data-id="element-254">
              DOMINAR AHORA
            </button>
          </div>
        </motion.div>}
    </AnimatePresence>;
}